export const RESET_CURRENT_SPECIALIST = "RESET_CURRENT_SPECIALIST";
export const FETCH_LIST_SPECIALIST_REQUEST = "FETCH_LIST_SPECIALIST_REQUEST";
export const FETCH_LIST_SPECIALIST_SUCCESS = "FETCH_LIST_SPECIALIST_SUCCESS";
export const FETCH_LIST_SPECIALIST_FAILURE = "FETCH_LIST_SPECIALIST_FAILURE";

// View single SPECIALIST
export const FETCH_SPECIALIST_REQUEST = "FETCH_SPECIALIST_REQUEST";
export const FETCH_SPECIALIST_SUCCESS = "FETCH_SPECIALIST_SUCCESS";
export const FETCH_SPECIALIST_FAILURE = "FETCH_SPECIALIST_FAILURE";

// Add SPECIALIST
export const ADD_SPECIALIST_REQUEST = "ADD_SPECIALIST_REQUEST";
export const ADD_SPECIALIST_SUCCESS = "ADD_SPECIALIST_SUCCESS";
export const ADD_SPECIALIST_FAILURE = "ADD_SPECIALIST_FAILURE";

// Edit SPECIALIST
export const UPDATE_SPECIALIST_REQUEST = "UPDATE_SPECIALIST_REQUEST";
export const UPDATE_SPECIALIST_SUCCESS = "UPDATE_SPECIALIST_SUCCESS";
export const UPDATE_SPECIALIST_FAILURE = "UPDATE_SPECIALIST_FAILURE";

// Delete SPECIALIST
export const DELETE_SPECIALIST_REQUEST = "DELETE_SPECIALIST_REQUEST";
export const DELETE_SPECIALIST_SUCCESS = "DELETE_SPECIALIST_SUCCESS";
export const DELETE_SPECIALIST_FAILURE = "DELETE_SPECIALIST_FAILURE";